<div class="hc-input-range" [class.hc-input-range--disabled]="disabled">
  <div class="hc-input-range__track-container">
    <input
      type="range"
      [id]="inputId"
      [min]="min"
      [max]="max"
      [step]="step"
      [value]="value"
      [disabled]="disabled"
      class="hc-input-range__slider"
      [style.--range-progress]="progressPercent + '%'"
      (input)="onInput($event)"
      (blur)="onBlur()" />
  </div>
  @if (showValue) {
    <span class="hc-input-range__value">{{ displayValue }}</span>
  }
</div>
